import { Chip, ChipProps, Tooltip, Typography, PopperProps } from '@mui/material'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import { ReactElement, ReactNode } from 'react'

/**
 * @deprecated This component is deprecated. Please use the `Chip` component from Material UI (`@mui/material`) instead.
 *
 * For usage recommendations and examples, refer to the Chip story in Storybook:
 * - Storybook path: "Data Display/Chip"
 *
 * The Material UI Chip component provides all the functionality you need with better maintainability
 * and consistency with the design system.
 *
 * Example migration:
 * ```tsx
 * // Old (deprecated)
 * <DefaultChip label="Example" />
 *
 * // New (recommended)
 * import { Chip } from '@mui/material'
 * <Chip label="Example" />
 * ```
 */
export interface ChipConfig extends ChipProps {
  label: string | NonNullable<ReactNode>
  tooltipLabel?: string | ReactNode
  endIcon?: ReactElement<string>
  avatarText?: string
  onEndIconClick?: () => void
  isDisabled?: boolean
  PopperProps?: Partial<PopperProps>
  tooltipPlacement?: PopperProps['placement']
}

/**
 * @deprecated This component is deprecated. Please use the `Chip` component from Material UI (`@mui/material`) instead.
 *
 * For usage recommendations and examples, refer to the Chip story in Storybook:
 * - Storybook path: "Data Display/Chip"
 *
 * The Material UI Chip component provides all the functionality you need with better maintainability
 * and consistency with the design system.
 */
export const DefaultChip = ({
  label,
  tooltipLabel,
  icon,
  avatarText,
  endIcon,
  onEndIconClick,
  tooltipPlacement,
  isDisabled,
  PopperProps,
  ...chipProps
}: ChipConfig) => {
  const renderChip = ({ title }: { title: string | undefined }) => (
    <Chip
      disabled={isDisabled}
      label={label}
      onDelete={!isNil(endIcon) ? onEndIconClick : undefined}
      avatar={!isEmpty(avatarText) ? <Typography>{avatarText}</Typography> : undefined}
      icon={icon}
      deleteIcon={endIcon}
      size="small"
      title={title}
      {...chipProps}
    />
  )

  if (tooltipLabel != null) {
    return (
      <Tooltip title={tooltipLabel} placement={tooltipPlacement} PopperProps={PopperProps}>
        {renderChip({ title: undefined })}
      </Tooltip>
    )
  }

  return renderChip({ title: typeof label === 'string' ? label : undefined })
}
